export default "__VITE_ASSET__Dv2Xi_TR__"